export const isTextMissing = (textValue: string) => {
  return textValue.length === 0;
};

export const isTextTooShort = (textValue: string, minLength: number) => {
  return textValue.length < minLength;
};

export const isTextTooLong = (textValue: string, maxLength: number) => {
  return textValue.length > maxLength;
};

export const isTextValid = (
  textValue: string,
  minLength: number,
  maxLength: number,
) => {
  return (
    !isTextMissing(textValue) &&
    !isTextTooShort(textValue, minLength) &&
    !isTextTooLong(textValue, maxLength)
  );
};
